module.exports = __webpack_public_path__ + "media/images/form-df28f6c965fd1edd28cb7ab6dc6106b1.svg";